import { useTranslation } from 'react-i18next';

import sharedStyles from './Shared.module.scss';

export const ScenarioNoResults = () => {
  const { t } = useTranslation('scenario');

  return (
    <div className={sharedStyles.container} data-testid="scenario-no-results">
      <img
        className={sharedStyles.img}
        src="/app/static/images/icons/no-results.svg"
        alt=""
      />
      <div className={sharedStyles.description}>
        <p className={sharedStyles.title}>
          {t('scenario:emptyState:noResultsTitle')}
        </p>
        <p className={sharedStyles.message}>
          {t('scenario:emptyState:noResultsMessage')}
        </p>
      </div>
    </div>
  );
};
